module.exports = __webpack_public_path__ + "static/ic-marin-d51ef9e385f94853d2d27e42b324e9c8.png";